__turbopack_context__.v({
  "app_light_theme": "subcategory-chips-module-scss-module__Fryd1a__app_light_theme",
  "chip": "subcategory-chips-module-scss-module__Fryd1a__chip",
  "root": "subcategory-chips-module-scss-module__Fryd1a__root",
});
